import React from "react";

export function isPurchased (item){
    return Boolean(item.purchase_date)
}

export function textDecorationByPurchaseState (item){
  return isPurchased(item) ? 'line-through' : 'none'
}
export function textColorByPurchaseState (item){
  return isPurchased(item) ?'#00000033' : 'text.primary'
}

export function getBuyCond (item){
    if(item.cond){
      return item.cond
    }

    if(item && item.purchase){
      for(let p of item.purchase){
        if(p.buy_cond){
          return p.buy_cond
        }
      }
    }

    return '결제조건없음'
}

